<template>
  <div class="item">
    <h5>{{name}}</h5>
    <div class="line-item" 
      v-for="(stat, i) in stats[statsGroup][statsObject]"
      :key="i"
      :class="{active:i==0}">
      <div class="label">
        <router-link class="clean no-top-left" :to="{name: 'cricketPlayer', params:{key: stat.key}}">
          {{stat.name}}
        </router-link>
      </div>
      <div class="number">
        <span class="highlight">{{stat.stats[statsGroup][statsField]}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    'stats': Object,
    'name': String,
    'statsGroup': String,
    'statsObject': String,
    'statsField': String,
  }
}
</script>

